import actions from './constants';

export const showAudits = (category, code, name, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_AUDITS,
  category,
  code,
  name,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showAuditsError = (category, code, error) => ({
  type: actions.SHOW_AUDITS_ERROR,
  category,
  code,
  error,
});

export const closeAudits = ({ category, code }) => ({
  type: actions.CLOSE_AUDITS,
  category,
  code,
});
